import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { GameManager } from "../../GameManager";

export class PreLoader extends Phaser.State {
    
    public static currentInstance: PreLoader;
    
    private preLoadItems: Phaser.Group;
    private loadedPercentageLabel: Phaser.Text;
    private loadingLabel: Phaser.Text;

    public init(): void {
        
        PreLoader.currentInstance = this;
    }
    
    public preload(): void {

        this.generateBitmapData();

        this.add.text(0, 0, "abcdefg", {font: "10px dnk", fill: "#000000"});
        this.add.text(0, 100, "abcdefg", {font: "10px whoopass", fill: "#000000"});
        this.add.text(0, 100, "abcdefg", {font: "10px Ubuntu", fill: "#000000"});
        this.add.text(0, 100, "abcdefg", {font: "10px Ubuntu Condensed", fill: "#000000"});

        // poner un fondo con un degradado
        const preloadBackground = this.add.sprite( 0, 0, this.game.cache.getBitmapData("intro_background"));
        preloadBackground.scale.setTo(48, 16);
        
        this.preLoadItems = this.add.group();

        //  Set-up our preloader sprite
        this.loadingLabel = new Phaser.Text( this.game, GameConstants.GAME_WIDTH / 2, 300, "LOADING...", { font: "42px Ubuntu Condensed", fill: "#ffffff"});
        this.loadingLabel.anchor.x = .5;
        this.loadingLabel.scale.y = GameVars.scaleY;
        this.add.existing(this.loadingLabel);

        // una etiqueta con el porcentaje de carga
        this.loadedPercentageLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 475, "0 %", { font: "32px Ubuntu Condensed", fill: "#ffffff"});
        this.loadedPercentageLabel.anchor.x = .5;
        this.preLoadItems.add (this.loadedPercentageLabel);

        this.loadAssets();
    }

    public create(): void {
        
        this.stage.disableVisibilityChange = true;

        GameManager.onGameAssetsLoaded();
    }

    public shutdown(): void {
        
        PreLoader.currentInstance = null;
    
        super.shutdown();
    }

    private updateLoadedPercentage(): void {

        this.loadedPercentageLabel.text = (this.load.progress).toString() + " %";
    }
    
    private loadAssets(): void {

        // atlas
        this.load.image("lawn-background", GameConstants.ASSETS_DIRECTORY + "/lawn-background.jpg");
        this.load.image("splash-background", GameConstants.ASSETS_DIRECTORY + "/splash_footchinko_responsive.jpg");

        this.load.atlasXML("texture_atlas_1", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_1.png",  GameConstants.ASSETS_DIRECTORY + "/texture_atlas_1.xml");
        this.load.atlasXML("texture_atlas_2", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_2.png",  GameConstants.ASSETS_DIRECTORY + "/texture_atlas_2.xml");
        this.load.atlasXML("texture_atlas_5", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_5.png",  GameConstants.ASSETS_DIRECTORY + "/texture_atlas_5.xml");

        if (!GameVars.gameData.introSeen ) {
            this.load.atlasXML("texture_atlas_3", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_3_en.png",  GameConstants.ASSETS_DIRECTORY + "/texture_atlas_3_en.xml");
        }

        // JSON
        this.load.json("levels", GameConstants.ASSETS_DIRECTORY + "/levels/levels.json");
        this.load.json("teams", GameConstants.ASSETS_DIRECTORY + "/config/teams.json");
        this.load.json("game_text", GameConstants.ASSETS_DIRECTORY + "/config/game_text.json");

        if (GameVars.gameData.tournamentData.length === 0) {
            this.load.json("tournamentsData", GameConstants.ASSETS_DIRECTORY + "/config/tournamentsData.json");
        }
        
        this.load.audio("soundtrack", [GameConstants.ASSETS_DIRECTORY + "/audio/soundtrack.mp3", GameConstants.ASSETS_DIRECTORY + "/audio/soundtrack.ogg"], true);
        this.load.audio("musica_menus", [GameConstants.ASSETS_DIRECTORY + "/audio/musica_menus.mp3", GameConstants.ASSETS_DIRECTORY + "/audio/musica_menus.ogg"], true);
        this.load.audio("musica_penalty", [GameConstants.ASSETS_DIRECTORY + "/audio/musica_penalty.mp3", GameConstants.ASSETS_DIRECTORY + "/audio/musica_penalty.ogg"], true);
        this.load.audio("musica_prorroga", [GameConstants.ASSETS_DIRECTORY + "/audio/musica_prorroga.mp3", GameConstants.ASSETS_DIRECTORY + "/audio/musica_prorroga.ogg"], true);
            
        // audiosprite
        this.load.audiosprite("audio_effects", [GameConstants.ASSETS_DIRECTORY + "/audio/audio_effects.mp3", GameConstants.ASSETS_DIRECTORY + "/audio/audio_effects.ogg"], GameConstants.ASSETS_DIRECTORY + "/audio/audio_effects.json");

        if (GameVars.showDailyRewardScene) {

            // el delantero que va a chutar
            this.load.atlasXML(GameConstants.DEFAULT_PLAYER_TEAM_ID.toString(), GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_PLAYER_TEAM_ID.toString() + ".png", GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_PLAYER_TEAM_ID.toString() + ".xml");

            // junto con el atlas que contiene los cofres
            this.load.atlasXML("texture_atlas_6", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_6.png",  GameConstants.ASSETS_DIRECTORY + "/texture_atlas_6.xml");
        }

        if (GameConstants.DEVELOPMENT) {
            this.load.atlasXML("texture_atlas_4", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_4.png", GameConstants.ASSETS_DIRECTORY + "/texture_atlas_4.xml");
            this.load.atlasXML(GameConstants.DEFAULT_PLAYER_TEAM_ID.toString(), GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_PLAYER_TEAM_ID.toString() + ".png", GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_PLAYER_TEAM_ID.toString() + ".xml");
            this.load.atlasXML(GameConstants.DEFAULT_ADVERSARY_TEAM_ID.toString(), GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_ADVERSARY_TEAM_ID.toString() + ".png", GameConstants.ASSETS_DIRECTORY + "/teams/" + GameConstants.DEFAULT_ADVERSARY_TEAM_ID.toString() + ".xml");
        }

        this.load.onFileComplete.add( this.updateLoadedPercentage, this);
    }

    private generateBitmapData(): void {

        // generar bitmapdatas
        let bmd_click = this.game.add.bitmapData( 16 , 128, "intro_orange", true);
        bmd_click.ctx.beginPath();
        bmd_click.ctx.rect(0, 0, 16, 128);
        bmd_click.ctx.fillStyle = "#ff5108";
        bmd_click.ctx.fill();

        let bmd =  this.game.add.bitmapData( 16 , 128, "intro_background", true);
        let grd = bmd.ctx.createLinearGradient(0, 0, 0, 128);
        grd.addColorStop(0, "#11c0e9"); // sets the first color
        grd.addColorStop(1, "#6fbe4d"); // sets the second color

        bmd.ctx.fillStyle = grd;
        bmd.ctx.fillRect(0, 0, 16, 128);

        bmd = this.game.add.bitmapData( 64 , 64, "black_square", true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, 64, 64);
        bmd.ctx.fillStyle = "#000000";
        bmd.ctx.fill();

        // el cuadrado blanco para el rectangulo del contenedor de trofeos
        bmd =  this.game.add.bitmapData( 16 , 16, "white_square", true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, 16, 16);
        bmd.ctx.fillStyle = "#ffffff";
        bmd.ctx.fill();

        // cuadrado verde para el layer de pausa
        bmd =  this.game.add.bitmapData( 16 , 16, "green_square", true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, 16,  16);
        bmd.ctx.fillStyle = "#2a8d1f";
        bmd.ctx.fill();

        // el cuadrado negro con degradado para rectangulo negro del contenedor de trofeos
        bmd = this.game.add.bitmapData( 16 , 64, "dark_gradient", true);
        grd = bmd.ctx.createLinearGradient(0, 0, 0, 64);
        grd.addColorStop(0, "#283939"); // sets the first color
        grd.addColorStop(1, "#000000"); // sets the second color
        bmd.ctx.fillStyle = grd;
        bmd.ctx.fillRect(0, 0, 16, 64);

        // el cuadrado negro con degradado para rectangulo negro del contenedor de trofeos
        bmd = this.game.add.bitmapData( 16 , 128, "penalty_curtain_gradient", true);
        grd = bmd.ctx.createLinearGradient(0, 0, 0, 128);
        grd.addColorStop(0, "#303a3b"); // sets the first color
        grd.addColorStop(1, "#121a1b"); // sets the second color
        bmd.ctx.fillStyle = grd;
        bmd.ctx.fillRect(0, 0, 16, 128);
    }
}
